import React from "react";
import "./CommentsPreview.css";
import {RESTComment} from "../services/types";
import Comment from "./Comment";

interface CommentsPreviewProps {
    comments: RESTComment[];
    onShowAllClick?: () => void;
    onCommentDeleted?: () => void;
}

const CommentsPreview: React.FC<CommentsPreviewProps> = ({ comments, onShowAllClick, onCommentDeleted }) => {
    const visibleCommentsCount = Math.min(comments.length, 3);
    const firstThreeComments = comments.slice(0, visibleCommentsCount);
    const hasMoreComments = comments.length > 3;
    const hiddenCommentsCount = comments.length - visibleCommentsCount;

    if (comments.length === 0) {
        return null;
    }

    return (
        <div className="CommentsPreview">
            <ul className="CommentsPreview-list">
                {firstThreeComments.map((comment) => (
                    <Comment 
                        key={comment.id} 
                        comment={comment}
                        onDeleted={onCommentDeleted}
                    />
                ))}
                
                {hasMoreComments && (
                    <li className="CommentsPreview-showAll">
                        <a 
                            href="#"
                            className="CommentsPreview-showAllLink"
                            onClick={(e) => {
                                e.preventDefault();
                                onShowAllClick?.();
                            }}
                        >
                            Afficher les {hiddenCommentsCount} autre{hiddenCommentsCount > 1 ? 's' : ''} commentaire{hiddenCommentsCount > 1 ? 's' : ''}
                        </a>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default CommentsPreview;
